<template>
  <div>
    <div v-show="showPin" class="pin-container" :class="{ 'no-button' : !showCollectButton, 'is-flex': showSideSwap}">
      <div class="user-pin-container">
        <img class="pin-background" :src="staticPinBackground">
        <div class="pin-upload">
          <div v-if="hasPinImage && !canUpload" class="pin-image cursor-pointer" v-bind:style="pinImageBackground"></div>
          <image-upload v-if="canUpload" class="pin-image" ref="pinUpload" :image="pinImage" :callback="setPin" :isPin="true" proxyWidth="100" proxyHeight="100"></image-upload>
        </div>
      </div>
      <div class="is-hidden-touch is-hidden-desktop-only button-container">
        <button v-if="showCollectButton" class="button is-link collect-button" @click="collectOrSignup()">{{collectPinButtonText}}</button>
      </div>
      <button v-if="showCollectButton" class="button swap-button is-hidden-widescreen" @click="collectOrSignup()">{{collectPinButtonText}}</button>
    </div>
    <modal-collect-pin-questions ref="pinCollectQuestions" :questions="questions" @modalSuccess="collectPin" @modalCancel="collectingPin = false"></modal-collect-pin-questions>
  </div>
</template>

<script>
import ImageUpload from '@/components/Inputs/ImageUpload'
import ModalCollectPinQuestions from '@/components/Modals/CollectPinQuestions'

import imageProxy from '@/libs/image-proxy'

import auth from '@/mixins/auth'

import i18n from '@/i18n'

export default {
  components: {
    ImageUpload,
    ModalCollectPinQuestions
  },
  props: ['project', 'showSideSwap', 'pinSize'],
  mixins: [auth],
  data: function () {
    return {
      collectingPin: false,
      hasPin: true,
      hasQuestions: false,
      pinImage: '',
      oldImage: '',
      questions: [],
      isCoOwner: false
    }
  },
  computed: {
    showPin: function () {
      return this.canUpload || this.hasPinImage
    },
    canUpload: function () {
      return ((this.project?.user?.id === this.currentUser?.id) || this.isCoOwner) && this.isLoggedIn
    },
    hasPinImage: function () {
      return this.pinImage !== ''
    },
    showCollectButton: function () {
      return !this.hasPin && !this.canUpload && this.hasPinImage
    },
    staticPinBackground: function () {
      return 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/staticImages%2FpinBackground.png?alt=media&token=313d6624-1c1c-4c4f-a97b-5dbe2e4fdfec'
    },
    proxiedPin: function () {
      let size = 125
      if (this.pinSize > 0) {
        size = this.pinSize
      }
      return this.pinImage ? imageProxy.proxy(this.pinImage, { width: size, height: size }) : ''
    },
    pinImageBackground: function () {
      const style = {}
      style.backgroundImage = `url('${this.proxiedPin}')`
      return style
    },
    collectPinButtonText: function () {
      if (this.$isGirlsAndSteam) {
        return i18n.t('projectPage.collectPinModal.collect')
      }

      if (this.hasQuestions || !this.isLoggedIn) {
        if (this.isMobile || window.innerHeight < 873) {
          return i18n.t('projectPage.collectPinModal.signup')
        } else {
          return i18n.t('projectPage.collectPinModal.signupAndCollect')
        }
      }

      return i18n.t('projectPage.collectPinModal.collect')
    },
    loginActive: function () {
      return this.$store.getters.modalIsVisible('login')
    }
  },
  mounted: function () {
    this.getPin()
    this.getUserMembership()
  },
  methods: {
    collectOrSignup: function () {
      // track collecting pin to prevent redirect after login
      this.collectingPin = true
      if (!this.isLoggedIn) {
        // on success doesnt really work here, because login causes the page to refresh
        return this.$store.dispatch('showLoginModal', { source: 'expobooth:' + this.project.id })
      } else {
        if (this.$isYSC) {
          this.collectPin()
        } else {
          this.$refs.pinCollectQuestions.showModal()
        }
      }
    },
    collectPin: function () {
      this.collectingPin = false
      this.$store.dispatch('collectProjectPin', this.project.id).then((response) => {
        this.hasPin = true
      }, (error) => {
        console.error(error)
      })
    },
    getPin: function () {
      this.$store.dispatch('getProjectPin', { projectID: this.project.id }).then((projectPin) => {
        if (projectPin) {
          this.pinImage = projectPin.url
          this.oldImage = projectPin.url
        }
      }).catch(error => {
        this.pinImage = ''
        this.oldImage = ''
        this.error = error.message
      })
      const data = { viewingUser: this.currentUser.userName, viewedUser: this.project.user.userName }
      this.$store.dispatch('getUserHasCollected', data).then((swappedPin) => {
        this.hasPin = swappedPin
        const templateID = this.$isGirlsAndSteam ? this.project.sourceProjectID : this.project.id
        const data = {
          templateID: templateID,
          excludeAnswered: true,
          context: 'pinCollect'
        }
        this.$store.dispatch('getTemplateCustomerQuestions', data).then((response) => {
          this.questions = response.questions
          this.hasQuestions = response.total > 0
          this.$nextTick(() => {
            // on login, the project refreshes. When this happens check if they were trying to collect pin and continue
            if (this.collectingPin && !this.hasPin) {
              this.collectOrSignup()
            } else {
              this.collectingPin = false
            }
          })
        }).catch(() => {
          this.questions = []
          this.hasQuestions = false
        })
      }, () => {
        this.hasPin = false
      })
    },
    savePin: function () {
      this.$refs.pinUpload.upload('projectPins', this.$partner + this.project.id).then((pinURL) => {
        this.$store.dispatch('updateProjectPin', { pinURL, projectID: this.project.id }).then(() => {
          this.editing = false
          this.pinImage = pinURL
          this.oldImage = pinURL
        }, () => {
          this.error = 'Unable to upload pin'
          this.pinImage = this.oldImage
        })
      }).catch(() => {
        this.pinImage = this.oldImage
        this.error = 'Unable to upload pin image'
      })
    },
    setPin: function (url) {
      if (this.pinImage === url) {
        return
      }

      this.pinImage = url

      this.$nextTick(() => {
        if (this.pinImage !== '') {
          this.savePin()
        }
      })
    },
    getUserMembership: function () {
      return this.$store.dispatch('getMembership', { project: this.project, user: this.currentUser }).then((membership) => {
        if (membership && membership.role === 'co-owner') {
          this.isCoOwner = true
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
.pin-container {
  position: relative;
  .user-pin-container {
    position: relative;
    width: 125px;
    height: 125px;
    @media (max-width: 1215px) {
      width: 60px;
      height: 60px;
    }
    .pin-background {
      height: 100%;
      position: relative;
      z-index: 5;
    }
    .pin-upload {
      position: absolute;
      width: 78%;
      height: 76%;
      bottom: 14%;
      right: 10%;
      .pin-image {
        position: absolute;
        z-index: 10;
        border-radius: 50%;
        height: 100%;
        width: 100%;
        background-position: center;
        background-size: inherit;
      }
    }
  }
  .button-container {
    display: flex;
    justify-content: space-around;
    margin-top: 0.5rem;
    .collect-button {
      margin: 0 auto;
    }
  }
  .swap-button {
    border: 1px solid #373737;
    background: transparent;
    color: #373737;
    font-size: 0.7rem;
    text-transform: uppercase;
    margin: auto 0.5rem;
    border-radius: 2px;
    font-weight: 500;
    padding: 0 1rem;
  }
}

::v-deep .pin-upload .button-upload {
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
}
</style>
